import { configureStore } from "@reduxjs/toolkit";
import componentInfo from "../models/Components/slice";
import dynamicPageInfo from "../models/DynamicPageInfo/slice";
import formData from "../models/FormData/slice";
import modalReducer from "../models/modalSlice";
import navAdditionalMenu from "../models/navAdditionalMenu/slice";
import navMenu from "../models/navigationMenu/slice";
import newsInfo from "../models/News/slice";
import projectInfo from "../models/ProjectInfo/slice";
import quotes from "../models/Quotes/slice";
import translationKeys from "../models/TranslationKeys/slice";
import ip from "../models/validateIP/slice";
const stringMiddleware = () => (next) => (action) => {
  if (typeof action === "string") {
    return next({
      type: action,
    });
  }
  return next(action);
};

const store = configureStore({
  reducer: {
    navMenu,
    navAdditionalMenu,
    formData,
    projectInfo,
    ip,
    componentInfo,
    dynamicPageInfo,
    quotes,
    newsInfo,
    translationKeys,
    modal: modalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(stringMiddleware),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
